<template>
  <lsm-widget
    :subtitle="caption"
    :image="locationHeroImage"
    data-testid="shift-widget"
  >
    <div
      v-if="shift.location?.name"
      class="font-weight-bold mb-2"
    >
      {{ shift.location?.name }}
    </div>
    {{ toLongDateWithDay(shift.date) }} | {{ toShortTime(shift.begins) }} - {{ toShortTime(shift.ends) }}
    <template #buttons>
      <v-btn
        color="primary"
        :to="shiftDetailsUrl"
        :text="t('shift.view_details')"
      />
    </template>
  </lsm-widget>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useDate } from '@/composables';
import LsmWidget from './LsmWidget.vue';

const props = defineProps<{
  shift: App.Models.Shift;
  caption: string;
}>();

const { t } = useI18n();

const { toLongDateWithDay, toShortTime } = useDate();
const shiftDetailsUrl = computed(() => `/shifts/details/${props.shift.id}`);

const locationHeroImage = computed(() => props.shift?.location?.hero_image?.signed_file_url ?? '/storage/images/defaut_location_hero.jpg');
</script>
